module.exports = __webpack_public_path__ + "assets/img/ic-qualified.28176e12.svg";